import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    backgroundColor: theme.palette.background.default,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default,
  },
  body: {
    display: 'flex',
    flex: 1,
    overflow: 'auto',
  },
}))

export default useStyles
